export default __webpack_public_path__ + "static/media/hero.8247286a.svg";